import script from "./DashboardMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardMenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardMenuItem.vue?vue&type=style&index=0&id=967fcdc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-967fcdc2"]])

export default __exports__